import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_FRONT_CREATE_MESSAGE,
} from 'api/actionTypes';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

const formFields = [
  {
    id: 'message',
    type: 'long_text',
    properties: {
      placeholder: 'Message...',
    },
  },
  {
    id: 'archiveConversation',
    type: 'hidden',
  },
];

@withApiState(({ user }) => ({
  createFrontMessageApiState: {
    action: SR_API_ACTION_FRONT_CREATE_MESSAGE,
    queryId: user.phone,
  },
}))
class SrFrontConversationForm extends Component {
  static propTypes = {
    frontConversation: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    onMessageSent: PropTypes.func.isRequired,
    createFrontMessageApiState: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
  }

  _onCreateMessage = (values, formikBag) => {
    const {
      frontConversation,
      user,
      dispatch,
      onMessageSent,
      currentUser,
    } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_FRONT_CREATE_MESSAGE,
      queryId: user.phone,
      payload: {
        message: values.message,
        channelId: frontConversation.channelId || user.frontChannelId,
        phone: user.phone,
        archiveConversation: values.archiveConversation,
        authorId: currentUser.frontTeammateId,
      },
      onSuccess:(frontMessage) => {
        formikBag.resetForm();
        onMessageSent(frontMessage);
      },
    });
  }

  render() {
    const {
      createFrontMessageApiState,
    } = this.props;

    return (
      <Formik
        enableReinitialize
        validateOnChange={false}
        initialValues={createInitialValues({
          formFields: formFields,
          defaultValues: {},
        })}
        onSubmit={this._onCreateMessage}
        validate={createFormValidationFn(formFields)}
        render={(formikBag) => {
          return (
            <Form className='SrFrontConversationForm'>
              <SrFormikField
                key={formFields[0].id}
                formField={formFields[0]}
                formikBag={formikBag}
              />
              <div className='actions'>
                <ButtonDeprecated
                  className='save'
                  onClick={() => {
                    formikBag.setFieldValue('archiveConversation', false);
                    formikBag.handleSubmit();
                  }}
                  disabled={!formikBag.isValid || createFrontMessageApiState.inProgress}
                >
                  {createFrontMessageApiState.inProgress && !formikBag.values.archiveConversation
                    ? 'sending...'
                    : 'send'
                  }
                </ButtonDeprecated>

                <ButtonDeprecated
                  className='archive'
                  theme={BUTTON_THEME_BLUE}
                  onClick={() => {
                    formikBag.setFieldValue('archiveConversation', true);
                    formikBag.handleSubmit();
                  }}
                  disabled={!formikBag.isValid || createFrontMessageApiState.inProgress}
                >
                  {createFrontMessageApiState.inProgress && formikBag.values.archiveConversation
                    ? 'sending...'
                    : 'send + archive'
                  }
                </ButtonDeprecated>
              </div>
              {createFrontMessageApiState.error && (
                <div className='formMessage error'>
                  <span>{createFrontMessageApiState.error.message}</span>
                </div>
              )}
            </Form>
          );
        }}
      />
    );
  }
}

SrFrontConversationForm.displayName = 'SrFrontConversationForm';

export default SrFrontConversationForm;
